import { useEffect, useState } from "react";

import { FetchStatus } from "../../../../base/types";
import { IAsyncBoundProperties } from "../../../../base/hooks";
import { IWebcamImageProps } from "./models/IWebcamImageProps";

export const WebcamImageProperties = []

export const useWebcamImageProperties = (props: IAsyncBoundProperties) => {
    const { status, result: bindings, error } = props;
    const [properties, setProperties] = useState<IWebcamImageProps>()

    useEffect(() => {
        if (status !== FetchStatus.Success || !bindings)
            return;

        const attributes: IWebcamImageProps = {};

        setProperties(attributes)
        // eslint-disable-next-line
    }, [bindings, status]);

    return { status, error, bindings, properties }
}